import React, { useState, useEffect, useRef } from "react";
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import { DateRange, Calendar } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import "../../assets/css/date-range-picker.css";



const DateRangePicker = ({ onChange, mode = 'range' }) => {
    const [rangeState, setRangeState] = useState([
        {
          startDate: null,
          endDate: null,
          key: 'selection'
        }
      ]);
    const [singleDateState, setSingleDateState] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const pickerRef = useRef(null);

    const formatDisplayDate = (date) => {
        if (!date) return '';
        const formatString = "EEE dd MMM yy";
        const formatted = format(date, formatString, { locale: fr });
        const capitalize = (s) => s.charAt(0).toUpperCase() + s.slice(1);
        return capitalize(formatted).replace(/(\w{3}) (\d{2}) (\w{3}) (\d{2})/, '$1. $2 $3. $4');
    };

    const displayedText = () => {
        if (mode === 'range') {
            const start = formatDisplayDate(rangeState[0].startDate);
            const end = formatDisplayDate(rangeState[0].endDate);
            if (start && end) {
                return `${start} > ${end}`;
            } else if (start) {
                return start;
            }
            return "Sélectionner une période";
        } else {
            const selected = formatDisplayDate(singleDateState);
            return selected || "Sélectionner une date";
        }
    };

    const handleRangeChange = (item) => {
        const newState = [item.selection];
        setRangeState(newState);
    };

    const handleSingleDateChange = (date) => {
        setSingleDateState(date);
        setIsOpen(false);
    };

    useEffect(() => {
        if (!onChange) return;

        if (mode === 'range' && rangeState[0].startDate && rangeState[0].endDate) {
            onChange({ startDate: rangeState[0].startDate, endDate: rangeState[0].endDate });
        } else if (mode === 'single' && singleDateState) {
            onChange({ selectedDate: singleDateState });
        }
    }, [rangeState, singleDateState, mode, onChange]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (pickerRef.current && !pickerRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [pickerRef]);

    return (
        <div className="drp-container" ref={pickerRef}>
             <button type="button" className="drp-button" onClick={() => setIsOpen(!isOpen)}>
                 <i className="fa-regular fa-calendar-days drp-icon"></i>
                 <span className="drp-text">{displayedText()}</span>
            </button>

            {isOpen && (
                <div className="drp-calendar-popup">
                   {mode === 'range' ? (
                       <DateRange
                            editableDateInputs={true}
                            onChange={handleRangeChange}
                            moveRangeOnFirstSelection={false}
                            ranges={rangeState}
                            locale={fr}
                            months={1}
                            direction="horizontal"
                            rangeColors={['#0056b3']}
                            className="drp-calendar-component"
                        />
                   ) : (
                       <Calendar
                            date={singleDateState || new Date()}
                            onChange={handleSingleDateChange}
                            locale={fr}
                            color={'#0056b3'}
                            className="drp-calendar-component"
                       />
                   )}
                </div>
            )}
        </div>
    );
}

export default DateRangePicker;